import { FC, memo } from 'react'

import { Flex, Text } from '@chakra-ui/react'

import { Tooltip, useSideMenuCollapsed } from '@enechain/ecloud-designsystem'

import { FallbackImage } from '~/components/parts/FallbackImage'

export type SideMenuLayoutOrganizationProps = {
  name: string
  src?: string
}

const SideMenuLayoutOrganization: FC<SideMenuLayoutOrganizationProps> = ({
  name,
  src,
}: SideMenuLayoutOrganizationProps) => {
  const { collapsed } = useSideMenuCollapsed()

  return (
    <Flex
      alignItems="center"
      justifyContent="flex-start"
      gap="2"
      width={collapsed === false ? 'full' : '32px'}
      marginBottom="2"
      padding={0}
    >
      <FallbackImage
        width="32px"
        height="32px"
        margin={0}
        padding={0}
        borderRadius="radiiBase"
        aria-hidden
        fallbackSrc="https://storage.googleapis.com/enec-eauth-prod-bucket/organization/default"
        src={src}
      />
      {collapsed === false && (
        <Tooltip
          backgroundColor="gray.900"
          borderRadius="radiiBase"
          label={name}
          placement="top"
        >
          <Text
            textStyle="textSm"
            overflow="hidden"
            color="Text.highEmphasis"
            fontWeight="bold"
            whiteSpace="nowrap"
            textOverflow="ellipsis"
          >
            {name}
          </Text>
        </Tooltip>
      )}
    </Flex>
  )
}

export default memo(SideMenuLayoutOrganization)
